"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormatPercent = void 0;
var _hooks = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Returns props `value` formatted as the percentage.
 * @see {@link useFormatPercent} for more information.
 *
 * @see {@link FormatPercentProps} for the available props and options.
 * @example
  // basic usage
  <FormatPercent value={1234.567} />

  // specify number of decimals to display
  <FormatPercent value={1234.567} options={{ decimals: Decimals.One }} />
 */
const FormatPercent = ({
  children,
  value,
  options
}) => {
  const formattedValue = (0, _hooks.useFormatPercent)(value ?? children, options);

  // eslint-disable-next-line react/jsx-no-useless-fragment -- false positive
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: formattedValue
  });
};
exports.FormatPercent = FormatPercent;
